import { connect } from 'react-redux';

import { companyPageUrl, companyLogoUrl } from '../HeaderComponentSelectors';
import Branding from './Branding';

function mapStateToProps(state) {
  return {
    companyPageUrl: companyPageUrl(state),
    companyLogoUrl: companyLogoUrl(state),
  };
}

function BrandingContainer({ ...props }) {
  return <Branding {...props} />;
}

export default connect(mapStateToProps)(BrandingContainer);
